import React from 'react';
import { Header } from '../components/layout/Header';
import { HeroSection } from '../components/sections/HeroSection';
import { ShowroomSection } from '../components/sections/ShowroomSection';
import { AdvantageSection } from '../components/sections/AdvantageSection';
import { StoneTypesSection } from '../components/sections/StoneTypesSection';
import { ProjectsSection } from '../components/sections/ProjectsSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { FinalCtaSection } from '../components/sections/FinalCtaSection';
export function Landing() {
  return <div className="w-full bg-white" data-id="element-116" data-mp="c9xi64370tmk">
      <Header data-id="element-117" data-mp="c8w6bxecs33s" />
      <main data-id="element-118" data-mp="c8miafcvc60q">
        <HeroSection data-id="element-119" data-mp="cb8n478dk7f9" />
        <ShowroomSection data-id="element-120" data-mp="h8qy035ycwpw" />
        <AdvantageSection data-id="element-121" data-mp="h9jumbb765ub" />
        <StoneTypesSection data-id="element-122" data-mp="habqzocmc7ln" />
        <ProjectsSection data-id="element-123" data-mp="m7lfn1s6of8f" />
        <TestimonialsSection data-id="element-124" data-mp="m6sgomzguu0u" />
        <ProcessSection data-id="element-125" data-mp="m83hqf1j1no9" />
        <FinalCtaSection data-id="element-126" data-mp="m58z8t22qcxh" />
      </main>
    </div>;
}